var React       = require('react');

var SaveButton  = require('patternity/lib/save-button');
var ButtonGroup = require('patternity/lib/button-group');
var ActionAlert = require('patternity/lib/alert/action_alert');
var Alert       = require('patternity/lib/alert');
var Icon        = require('infl-icons').Icon;
var Button      = require('patternity/lib/button2').Button;
var { withNamespaces } = require('react-i18next');

var QuizActions = React.createClass({
  propTypes: {
    onSubmit: React.PropTypes.func.isRequired,
    completed: React.PropTypes.bool.isRequired,
    submitLabel: React.PropTypes.string.isRequired,
    challengeId: React.PropTypes.number.isRequired,
    status: React.PropTypes.string.isRequired,
    pointsEarned: React.PropTypes.number.isRequired,
    totalQuestions: React.PropTypes.number.isRequired,
    correctQuestions: React.PropTypes.number.isRequired,
    quizAnswered: React.PropTypes.bool.isRequired,
    submitDisabled: React.PropTypes.bool.isRequired
  },

  getInitialState: function() {
    return {
      reallyCompleteHackToFixContinueButtonShowingAfterFinishContinue: false
    };
  },

  render: function () {
    return this.props.completed ?
      this._renderFinishStage() :
      this._renderActions();
  },

  _renderActions: function() {
    return this.props.quizAnswered ? this._renderContinue() : this._renderSubmit();
  },

  _renderSubmit: function () {
    return (
      <div className='pt-form-actions'>
        <ButtonGroup layout='inline'>
          <a className="reject button text" href={'/challenges/'+this.props.challengeId+'/dismiss'}>{this.props.t('Later')}</a>
          <SaveButton
              type='primary'
              isSubmit={false}
              saveStatus={this.props.status}
              customText={{
                unsaved: this.props.submitLabel,
                saved: 'Submitted',
                saving: 'Submitting',
                error: 'Error'
              }}
              disabled={this.props.submitDisabled}
              onClick={this.props.onSubmit}
              className={this.props.submitDisabled && 'c-button-disabled'}  >
            {this.props.submitLabel}
          </SaveButton>
        </ButtonGroup>
      </div>
    );
  },

  _renderFinishStage: function () {
    if(this.state.reallyCompleteHackToFixContinueButtonShowingAfterFinishContinue) {
      return (
        <div style={this.styles.continue} className="quiz-complete">
          <Alert title='Stage already completed' type='success'></Alert>
        </div>
      );
    }

    return (
      <div style={this.styles.continue} className="quiz-complete">
        <ActionAlert
            title='Stage already completed'
            action={{
              title: 'Continue',
              onClick: this._handleFinishStateContinue
            }}
            type='success'>
        </ActionAlert>
        <span style={{display: 'none'}} ref="hiddenSubmit">
          <Button onClick={function(){}} isSubmit={true}>{this.props.t('Continue')}</Button>
        </span>
      </div>
    )
  },

  _handleFinishStateContinue: function() {
    this.setState({
      reallyCompleteHackToFixContinueButtonShowingAfterFinishContinue: true
    });
    this.refs.hiddenSubmit.querySelector('button').click();
  },

  _renderContinue: function () {
    return (
      <div style={this.styles.continue} className="c-quiz-continue-tally">
        {this._continueTitle()}
        <Button
          style={this.styles.continueButton}
          className="c-continue-button"
          type="primary" onClick={function(){}}
          isSubmit={true}>{this.props.t('Continue')}</Button>
      </div>
    );
  },

  _continueTitle: function() {
    var questionsCorrect = this.props.t('You earned');
    if(this.props.totalQuestions > 1) {
      questionsCorrect = this.props.t('You got {{correct_questions}} of {{total_questions}} correct and earned', {correct_questions: this.props.correctQuestions, total_questions: this.props.totalQuestions});
    }

    return (
      <span style={this.styles.pointsEarned}>
        { questionsCorrect }
        <span className="c-icon-wrapper" style={this.styles.pointsIcon}>
          <Icon icon="coins" />
        </span>
        { this.props.pointsEarned }
      </span>
    )
  },

  styles: {
    continue: {
      marginTop: '10px',
      clear: 'right',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    pointsEarned: {
      fontSize: 18
    },
    continueButton: {
      float: 'right'
    },
    pointsIcon: {
      position: 'relative',
      top: '1px',
      fontSize: 13,
      marginLeft: '5px',
      marginRight: '5px'
    }
  }
});

module.exports = withNamespaces()(QuizActions);



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/components/quiz_actions.jsx